import { useState } from 'react';
import Table, { useTable } from 'common/components/table';
import TableActions from 'components/layouts/table';
import Form from './form';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import useDrawer from 'common/components/drawer/useDrawer';

import edit from 'assets/svg/actions/edit-empty.svg';

const Users = () => {
  const [active, setActive] = useState(null);
  // const [updateUser, archiveUser] = useActions([
  //   usersActions.updateUser,
  //   usersActions.archiveUser
  // ]);
  const drawer = useDrawer(false);
  const table = useTable({
    label: 'orca-users',
    columns: [
      {
        header: 'ID',
        key: 'id',
        type: 'number',
        className: 'text-start',
        sort: true
      },
      {
        header: 'Name',
        key: 'full_name',
        className: 'text-start',
        type: 'string',
        sort: true
      },
      {
        header: 'Email',
        key: 'email',
        className: 'text-start',
        type: 'string',
        sort: true
      },
      {
        header: 'Username',
        key: 'username',
        className: 'text-start',
        type: 'string',
        sort: true
      },
      {
        header: 'Company',
        key: 'organization_name',
        className: 'text-start',
        type: 'string',
        sort: true
      },
      {
        header: 'First Sign In',
        key: 'created_at',
        className: 'text-start',
        type: 'datetime',
        sort: true
      },
      {
        header: 'Part Of',
        key: 'on_board_access',
        className: 'text-start',
        type: 'boolean',
        options: [
          { label: 'On Board', value: true },
          { label: 'Office', value: false }
        ],
        sort: true
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  return (
    <Row>
      <Col xs={12} className="mb-5">
        <TableActions
          title="Users"
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Add User',
              color: 'primary',
              onClick: () => {
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          bulk={true}
          bulkActions={[]}
          className="bulk-container-middle"
          drawer={<Form drawer={drawer} active={active} />}
          onArchive={() => {}}
          rows={{
            created_at: data => (
              <div className="d-flex align-items-start flex-column">
                <span className="fs-12">{moment(data.created_at).format('DD/MM/YYYY')}</span>
                <span className="fs-12 text-violet">
                  {moment(data.created_at).format('HH:mm:ss')}
                </span>
              </div>
            ),
            on_board_access: data => (data.on_board_access ? 'On Board' : 'Office'),
            actions: {
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            }
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default Users;
